import React from 'react';
import { FaGithub } from 'react-icons/fa';
import './Project.css';
export default function Project() {
  return (
    <section id='project' className='project-section'>
      <div className='heading'>
        <h1>Projects</h1>
      </div>
      <div className='projects'>
        <div class='card'>
          <div class='card-details'>
            <p class='text-title'>Lost & Found Application</p>
            <p class='text-body'>Nodejs, MongoDB</p>
          </div>
          <button class='card-button'>
            <a target='_blank' href='https://github.com/pankajasiwal/Lost-and-found-Application'>
              <FaGithub style={{ fontSize: '1.5em', color: 'white' }} />
            </a>
          </button>
        </div>

        <div class='card'>
          <div class='card-details'>
            <p class='text-title'>Movie Searching Application</p>
            <p class='text-body'>ReactJS</p>
          </div>
          <button class='card-button'>
            <a target='_blank' href='https://github.com/pankajasiwal/Movie-Searching-App'>
              <FaGithub style={{ fontSize: '1.5em', color: 'white' }} />
            </a>
          </button>
        </div>

        <div class='card'>
          <div class='card-details'>
            <p class='text-title'>Speech to Tex</p>
            <p class='text-body'>JavaScript</p>
          </div>
          <button class='card-button'>
            <a target='_blank' href='https://github.com/pankajasiwal/speech-to-text'>
              <FaGithub style={{ fontSize: '1.5em', color: 'white' }} />
            </a>
          </button>
        </div>

        <div class='card'>
          <div class='card-details'>
            <p class='text-title'>Instagram Follow Card</p>
            <p class='text-body'>HTML, CSS</p>
          </div>
          <button class='card-button'>
            <a target='_blank' href='https://github.com/pankajasiwal/insta-follow-Card-Web-Development'>
              <FaGithub style={{ fontSize: '1.5em', color: 'white' }} />
            </a>
          </button>
        </div>

        <div class='card'>
          <div class='card-details'>
            <p class='text-title'>Netflix Clone</p>
            <p class='text-body'>HTML, CSS</p>
          </div>
          <button class='card-button'>
            <a target='_blank' href='https://github.com/pankajasiwal/Netflix-Clone'>
              <FaGithub style={{ fontSize: '1.5em', color: 'white' }} />
            </a>
          </button>
        </div>

        <div class='card'>
          <div class='card-details'>
            <p class='text-title'>Landing Page</p>
            <p class='text-body'>HTML, CSS</p>
          </div>
          <button class='card-button'>
            <a target='_blank' href='https://github.com/pankajasiwal/landing-page-web-development'>
              <FaGithub style={{ fontSize: '1.5em', color: 'white' }} />
            </a>
          </button>
        </div>
      </div>
    </section>
  );
}
